<template>

    <div>
        <!-- 登录页面 -->
        <div v-if="step === 1">
            <loginPage ref="loginPage"></loginPage>
        </div>

        <div v-if="step === 2" class="back-div">
            <div class="main-page" ref="mainPage">
                <!--<van-button @click="testPay">支付</van-button>-->
                <div class="dialog-mask" v-show="diyDialogShow">
                    <div class="diy-dialog">
                        <div style="text-align: center;height: 30px;line-height: 30px;">温馨提示</div>
                        <div style="padding: 3px 15px;text-align: left;box-sizing: border-box;margin-top: 10px;">
                            即将打开支付页面，请点击"立即支付"按钮完成支付
                        </div>
                        <div class="diy-dialog-buttons">
                            <div @click="closeDiyDialog()"
                                 style="flex: 1;text-align: center;height: 45px;line-height: 45px;">
                                <a style="color: #888888">取消</a>
                            </div>
                            <div style="flex: 1;text-align: center;height: 45px;line-height: 45px;border-left: 1px solid #f0f0f0;">
                                <a target="_blank" :href="payUrl" @click="closeDiyDialog()"
                                   style="color:#f16868;">立即支付</a>
                            </div>
                        </div>

                    </div>
                </div>

                <iframe v-show="true" allowfullscreen ref="gameIframe" :src="gameUrl" frameborder="0" scrolling="no"
                        width="100%" height="100%">
                </iframe>

                <van-notice-bar  v-if="showNotice" delay="0"  :style="noticeStyle" style="color: #eca007;pointer-events: none;position: absolute;top: 100px;left: 50%; transform: translate(-50%, -50%); font-size: 14px;width: 100%;max-width: 450px; height: 35px;background-color: rgba(0,0,0,.4)"
                                 speed="30"  :text="noticeMessage" @replay="hideNotice"/>

                <van-dialog :style="dialogStyle" v-model="payShow" class="pay-dialog" :showConfirmButton="false">
                    <pay ref="pay"></pay>
                </van-dialog>

                <van-dialog class="pay-code-dialog" v-model="payCodeShow" v-if="payCodeShow" :showConfirmButton="false">
                    <pay-code ref="payCode"></pay-code>
                </van-dialog>

                <van-dialog :style="dialogStyle" class="main-dialog" v-model="videoPageDialogShow"
                            :showConfirmButton="false">
                    <videoPage ref="videoPage" v-if="videoPageShow"></videoPage>
                </van-dialog>

                <van-dialog :style="dialogStyle" class="main-dialog" v-model="realNameShow" v-if="realNameShow"
                            :showConfirmButton="false">
                    <real-name ref="realNameDialog" v-if="realNameShow"></real-name>
                </van-dialog>

                <van-dialog :style="dialogStyle" class="main-dialog" v-model="bingTelShow" v-if="bingTelShow"
                            :showConfirmButton="false">
                    <bind-tel ref="bindTelDialog" v-if="bingTelShow"></bind-tel>
                </van-dialog>

                <van-dialog :style="dialogStyle" class="main-dialog" v-model="mainDialogShow" v-if="mainDialogShow" close-on-click-overlay
                            :showConfirmButton="false">
                    <iframe v-if="mainDialogShow" :src="iframeUrl" frameborder="0" scrolling="no" style="width: 100%;height: 320px;"/>
                </van-dialog>

                <van-popup v-model="iframeDialogShow" class="iframe-dialog" position="center" :style="{ width: '100%', height: '100%' }" >
                    <div @click="iframeDialogShow = false" style="width: 35px;height: 35px;position: absolute;top: 10px;left: 10px;
                            background-color: rgba(255,255,255,.2);text-align: center;padding-top: 2px; box-sizing: border-box; border-radius: 4px;">
                        <img src="../../assets/back.png" style="width: 30px;">
                    </div>
                    <iframe v-if="iframeDialogShow" allowfullscreen ref="drawIframe" :src="drawUrl" frameborder="0" scrolling="no"
                             width="100%" height="100%">
                    </iframe>
                </van-popup>

                <van-dialog v-model="gameNoticeDialogShow" style="" position="center" close-on-click-overlay :show-confirm-button="false">
                    <div style="padding: 10px 15px 0;">
                        <div style="font-size: 18px;font-weight: bold;color: #333333">
                            {{gameNoticeTitle}}
                        </div>

                        <div v-html="gameNoticeContent.replaceAll('\n', '<br/>')"
                             style="text-align: left;margin-top: 15px;color: #555555;font-size: 14px;min-height: 80px;max-height: 300px;overflow-y: auto;">
                        </div>
                        <div style="display: flex;width: 100%;height: 45px;border-top: 1px solid #eaeaea;margin-top: 5px;font-size: 14px;">
                            <div @click="gameNoticeDialogShow = false" style="flex: 1;display: flex;align-items: center;justify-content: center;color: #888888">
                                确认
                            </div>
                            <div v-if="!!gameNoticeUrl" @click="openDetailUrl" style="flex: 1;display: flex;align-items: center;justify-content: center;color: #e14d48;border-left: 1px solid #eaeaea;">
                                查看详情
                            </div>
                        </div>
                    </div>
                </van-dialog>


                <div v-if="isShow" class="float-icon" id="floatIconView"
                     @mousedown="down($event)"
                     @touchstart="down($event)"
                     @mousemove="move($event)"
                     @touchmove="move($event)"
                     @mouseover="end($event)"
                     @mouseleave="move($event)"
                     @mouseup="end($event)"
                     @touchend="end($event)"
                     @click="showMainWindow">

                    <van-image  :src="logoRoundUrl" width="50px" height="50px"></van-image>

                </div>

                <div v-show="false">
                    <van-count-down
                            ref="countDown"
                            :time="time"
                            :auto-start="false"
                            format="ss"
                            @finish="finish"
                    />
                </div>
            </div>
            <van-overlay :show="openPageShow" @click="openPageShow = false">
                <div class="right-panel">
                    <van-icon @click="closeOutsidePage" style="font-size: 25px;" name="arrow-down"/>
                    <iframe ref="webview_iframe" v-show="true" style="overflow-x:auto;overflow-y:auto"
                            allowfullscreen
                            :src="openPageUrl"
                            frameborder="0"
                            width="100%"
                            height="100%" scrolling="yes">
                    </iframe>
                </div>
            </van-overlay>

            <movable-view v-if="autoClickButtonShow" class="auto-click-view" @moveEnd="moveEndButton" id="acSettingView" ref="acSettingView">
                <template>
                    <div v-if="!autoClickStarting" style="width: 140px;display: flex;align-items: center;justify-content: space-evenly;">
                        <div @click="runAutoClick">
                            <img src="../../assets/ldq/run.png" style="width: 22px;height: 22px;">
                            <div>运行</div>
                        </div>
                        <div @click="addPoint">
                            <img src="../../assets/ldq/plus.png" style="width: 22px;height: 22px;">
                            <div>新增</div>
                        </div>
                        <div @click="autoClickSettingShow = true">
                            <img src="../../assets/ldq/setting.png" style="width: 22px;height: 22px;">
                            <div>设置</div>
                        </div>
                    </div>
                    <div v-else style="width: 60px;">
                        <div @click="stopAutoClick">
                            <img src="../../assets/ldq/stop.png" style="width: 22px;height: 22px;">
                            <div>停止</div>
                        </div>
                    </div>
                </template>
            </movable-view>

            <movable-view @moveEnd="moveEndPoint" v-for="(item, index) in autoClickPointList" v-show="item.show === 1" class="rp-view" :style="{left: item.pointX - 15 + 'px', top: item.pointY - 15 + 'px'}">
                <template>
                    <img src="../../assets/ldq/point.png" style="position: absolute;width: 34px;height: 34px;">
                    <span>{{index + 1}}</span>
                </template>
            </movable-view>

            <van-dialog v-if="autoClickSettingShow" v-model="autoClickSettingShow" class="main-dialog" :showConfirmButton="false">
                <auto-click-setting></auto-click-setting>
            </van-dialog>

            <van-dialog v-if="autoClickListShow" v-model="autoClickListShow" class="main-dialog" :showConfirmButton="false">
                <auto-click-list></auto-click-list>
            </van-dialog>

            <give-gift v-if="giveGiftPageShow"></give-gift>

        </div>

    </div>
</template>

<script>

    import {logout, roleSync, request} from '@/api/request'
    import sdkUrl from '@/api/sdkurl'

    import bindTel from "@/components/bindtel.vue";
    import realName from "@/components/realname.vue";
    import pay from "@/components/pay.vue";
    import videoPage from "@/components/video.vue";
    import payCode from "@/components/pay-code.vue";
    import loginPage from "@/components/login.vue";
    import {Dialog, Toast} from 'vant';
    import timerhook from '@/utils/timerhook';
    import webConfig from "@/api/config";
    import notice from "@/api/notice";
    import GiveGift from "@/components/GiveGift.vue";
    import AutoClickSetting from "@/components/AutoClickSetting.vue";
    import AutoClickList from "@/components/AutoClickList.vue";
    import MovableView from "@/components/MovableView.vue";

    export default {
        name: 'mainPage',
        components: {
            'bind-tel': bindTel,
            'real-name': realName,
            'pay': pay,
            'videoPage': videoPage,
            'pay-code': payCode,
            loginPage,
            AutoClickSetting,
            AutoClickList,
            MovableView,
            GiveGift,
        },
        data() {
            return {
                heartBeatTime: 30000,
                step: 0,
                payShow: false,
                mainDialogShow: false,

                changePasswordShow: false,
                bingTelShow: false,
                unBingTelShow: false,
                realNameShow: false,
                kfShow: false,
                openPageShow: false,
                videoPageShow: false,
                videoPageDialogShow: false,
                payDialogShow: false,
                payCodeShow: false,
                iframeDialogShow: false,
                bindWeixinShow: false,
                diyDialogShow: false,
                rechargeShow: false,
                giftShow: false,
                giftRecordShow: false,

                flags: false,
                position: {x: 0, y: 0},
                nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
                isShow: false,

                channelId: '',
                gameId: '',

                buttonHidden: true,
                halfOffset: 0,
                time: 10000,
                firstClick: true,
                gameUrl: '',
                tempGameUrl: '',
                payUrl: '',
                screenModel: 1,//当前屏幕方向 1-竖屏 2-横屏
                screenType: 0,//游戏类型 1-竖屏 2-横屏
                dialogStyle: {},
                openPageUrl: '',//外部链接地址

                path: location.protocol + '//' + location.host + '/#' + this.$route.path, //当前页面url
                speedRate: 1,
                jsPageShow: false,
                drawUrl: '',
                hasRed: false,
                shoutId: 0,
                shoutMsgList: [],
                showNotice: false,
                noticeStyle: '',
                noticeMessage: '',
                heartBeatGameId: [],
                skipCheckTel: false,
                iframeUrl: '',
                logoRoundUrl: require("@/assets/logo-skeleton.png"),
                isAutoLogin: false,
                gameNoticeDialogShow: false,
                gameNoticeTitle: '',
                gameNoticeContent: '',
                gameNoticeUrl: '',
                noticeShowSwitch: true,

                windowWidth: 0,
                windowHeight: 0,
                pointIndex: 1,
                autoClickPointList: [],
                autoClickStarting: false,
                autoClickSettingShow: false,
                autoClickListShow: false,
                autoClickButtonShow: false,
                createOrUpdatePlan: 1,
                selectAutoClickPlanIndex: -1,
                autoClickPlan: {},
                currentLoopNum: 0,
                androidAppVersion: '',
                acViewLeft: null,

                giveGiftPageShow: false,
            };
        },
        mounted() {
            console.log('页面初始化');
            this.initUrlParams();
            this.transformChannel();
            this.handleLoginStatus();
            this.autoLogin();
            window.confirmLogout = this.confirmLogout;
            //this.drawUrl = webConfig.drawUrl;

            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
        methods: {
            async runAutoClick() {
                let pointNum = this.autoClickPointList.length;
                if (pointNum === 0) {
                    Toast('请先添加触点');
                    return;
                }
                this.autoClickStarting = true;
                if (this.acViewLeft) {
                    let acView = document.getElementById("acSettingView");
                    acView.style.left = (this.acViewLeft + 80) + 'px';
                }
                for (let i = 0; i < pointNum; i++) {
                    this.autoClickPointList[i].show = 0;
                }
                this.currentLoopNum = 0;
                await this.startAutoClick();
            },
            moveEndButton(x, y) {
                let acView = document.getElementById("acSettingView");
                if (acView.style.left) {
                    this.acViewLeft = parseInt(acView.style.left.replace('px', ''));
                    //console.log(this.acViewLeft);
                }
            },
            moveEndPoint(target) {
                let centerX = target.offsetLeft + 15;
                let centerY = target.offsetTop + 15;
                let index = parseInt(target.innerText);
                this.autoClickPointList[index - 1].pointX = centerX;
                this.autoClickPointList[index - 1].pointY = centerY;
            },
            stopAutoClick() {
                this.autoClickStarting = false;
                if (this.acViewLeft) {
                    let acView = document.getElementById("acSettingView");
                    acView.style.left = (this.acViewLeft) + 'px';
                }

                let pointNum = this.autoClickPointList.length;
                for (let i = 0; i < pointNum; i++) {
                    this.autoClickPointList[i].show = 1;
                }
            },
            enableAutoClickPlan(index) {
                let planList = JSON.parse(localStorage.getItem('autoClickPlanList')) || [];
                if (index >= planList.length ) {
                    Toast('数据出错了');
                    return;
                }

                this.autoClickPlan = planList[index];
                this.autoClickPointList = this.autoClickPlan.pointList;
                this.pointIndex = this.autoClickPointList.length + 1;
                this.autoClickButtonShow = true;
                this.autoClickListShow = false;
                this.createOrUpdatePlan = 2;
                this.selectAutoClickPlanIndex = index;
            },
            exitAutoClickPlan() {
                this.autoClickButtonShow = false;
                this.autoClickSettingShow = false;
                this.pointIndex = 1;
                this.autoClickPointList = [];
                this.currentLoopNum = 0;
            },
            createNewAutoClickPlan() {
                this.autoClickButtonShow = true;
                this.autoClickListShow = false;
                this.autoClickPointList = [];
                this.pointIndex = 1;
                this.addPoint();
                this.createOrUpdatePlan = 1;
                this.autoClickPlan = {
                    name: '',
                    loopNum: '',
                    loopInterval: '0',
                }
            },
            async startAutoClick() {
                this.currentLoopNum ++;
                let pointNum = this.autoClickPointList.length;
                for (let i = 0; i < pointNum; i++) {
                    let point = this.autoClickPointList[i];
                    await this.sleep(!point.timeInterval ? 1000 : point.timeInterval);

                    if (!this.autoClickStarting) {
                        break;
                    }

                    this.$nextTick(function() {
                        let xPercent = parseFloat((point.pointX / this.windowWidth).toFixed(4));
                        let yPercent = parseFloat((point.pointY / this.windowHeight).toFixed(4));
                        if (window.androidJs) {
                            try {
                                window.androidJs.doPoint(xPercent, yPercent);
                            }
                            catch (e) {
                                Toast('当前版本不支持该功能');
                                this.stopAutoClick();
                            }
                        }
                        else {
                            Toast('当前版本不支持该功能');
                            this.stopAutoClick();
                        }
                    });
                    setTimeout(() => {
                        point.show = 1;
                        setTimeout(() => {
                            if (this.autoClickStarting) {
                                point.show = 0;
                            }
                        },300);
                    },50);

                    //最后一个触点，判断是否继续循环
                    if (i === pointNum - 1) {
                        if (!this.autoClickPlan.loopNum || this.currentLoopNum < parseInt(this.autoClickPlan.loopNum)) {
                            let loopInterval = parseInt(this.autoClickPlan.loopInterval);
                            if (loopInterval > 0) {
                                await this.sleep(loopInterval);
                            }
                            await this.startAutoClick();
                        }
                        else {
                            this.stopAutoClick();
                        }
                    }
                }
            },
            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            addPoint() {
                let index = this.pointIndex ++;
                let x = this.windowWidth * 0.5;
                let y = this.windowHeight * 0.2;
                let point = {timeInterval: null, pointX: x, pointY: y, show: 1};
                this.autoClickPointList.push(point);
                Toast('已添加触点' + index);
            },

            initUrlParams() {
                this.from = this.$route.query.from || 'h5';
                console.log('main, from: ' + this.from);
                localStorage.setItem('from', this.from);
                this.channelId = this.$route.path.split('/')[2];
                this.gameId = this.$route.path.split('/')[3];

                //处理同一个浏览器  多个标签打开不同的游戏  之前存的token属于不同的游戏，需要清除 重新登录
                /*let localGameId = localStorage.getItem('gameId');
                if (!!localGameId && localGameId !== this.gameId) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                }*/

                localStorage.setItem("channelId", this.channelId);
                localStorage.setItem("gameId", this.gameId);

                if (this.$route.query.device) {
                    localStorage.setItem('device', this.$route.query.device);
                }

                if (!localStorage.getItem('udid') && this.$route.query.udid) {
                    localStorage.setItem('udid', this.$route.query.udid);
                }
                if (!localStorage.getItem('udid')) {
                    localStorage.setItem('udid', this.generateUUID());
                }
            },
            startGame() {
                this.gameUrl = this.tempGameUrl;
                this.queryGameNotice();
            },
            queryGameNotice() {
                let options = {
                    url:"/h5/getGameNotice",
                    data: {
                        gameId: this.gameId
                    }
                };
                request(options).then(res => {
                    if(res.data.success){
                        let gameNotice = res.data.data;
                        if (gameNotice) {
                            this.gameNoticeDialogShow = true;
                            this.gameNoticeTitle = gameNotice.title;
                            this.gameNoticeContent = gameNotice.content;
                            this.gameNoticeUrl = gameNotice.url;
                        }

                    } else {
                        //this.$toast(res.data.error.message);
                    }
                })
            },
            openDetailUrl() {
                notice.startIntent(this.gameNoticeUrl);
                this.gameNoticeDialogShow = false;
            },
            autoLogin(){
                let credential = this.$route.query.credential;
                if(!credential){
                    return;
                }
                this.isAutoLogin = true;
                let options = {
                    url:"/web/loginGameWithCredential",
                    data: {
                        userCredential: credential,
                        gameId: this.gameId,
                    }
                };
                request(options).then(res => {
                    let newPath = window.location.origin + '/#' + this.$route.path;
                    console.log(newPath)
                    //window.location.href = newPath;
                    history.replaceState({}, '', newPath);
                    if(res.data.success){
                        localStorage.setItem('token', res.data.data.token);
                        localStorage.setItem('user', JSON.stringify(res.data.data));
                        localStorage.setItem('loginUrl', res.data.data.loginUrl);
                        Toast('登录成功');
                        this.enterGame();
                    }else {
                        this.$toast(res.data.error.message);

                    }
                })
            },
            generateUUID(){
                let d=new Date().getTime();
                let uuid ='xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            },
            transformChannel() {
                let thirdChannel = this.$route.query.thirdChannel || '';
                if (!thirdChannel) {
                    return;
                }
                let options = {
                    url:"/h5/transformChannel?channelConfig=" + thirdChannel,
                    method: 'get',
                };
                request(options).then(res => {
                    if (res.data.success) {
                        let result = res.data.data;
                        console.log('渠道号转化成功，第三方渠道号: ' + thirdChannel + ", 转换结果: " + result);
                        localStorage.setItem("channelId", result);
                    }
                    else {
                        console.log('渠道号转化失败');
                    }
                });
            },
            handleLoginStatus () {
                this.step = 1;
                this.$nextTick(function () {
                    this.$refs.loginPage.from = this.from;
                })
            },
            /*handleLoginStatus() {
                let userInfo = localStorage.getItem('user');
                let token = localStorage.getItem('token');
                console.log('userInfo', !userInfo);
                console.log('token', !token);
                if (!!userInfo && !!token) {
                    let options = {
                        url:"/h5/refreshGame",
                        data: {
                            gameId: this.gameId
                        }
                    };
                    request(options).then(res => {
                        if (res.data.success) {
                            let gameUrl = res.data.data;
                            localStorage.setItem('loginUrl', gameUrl);
                            this.skipCheckTel = true;
                            this.enterGame();
                        }
                        else {
                            this.step = 1;
                            this.$nextTick(function () {
                                this.$refs.loginPage.from = this.from;
                            })
                        }
                    });
                }
                else {
                    this.step = 1;
                    this.$nextTick(function () {
                        this.$refs.loginPage.from = this.from;
                    })
                }
            },*/
            enterGame() {
                this.step = 2;
                let user = JSON.parse(localStorage.getItem("user"));
                if (!!user) {
                    this.screenType = user.screenType;
                }

                //开启心跳的游戏id
                if(this.heartBeatGameId.includes(parseInt(this.gameId))) {
                    this.heartBeat();
                    this.showShoutMsg();
                }

                this.tempGameUrl = localStorage.getItem('loginUrl');
                localStorage.removeItem('loginUrl');
                this.logoRoundUrl = webConfig.logoRoundUrl;
                this.isShow = true;
                this.$nextTick(function () {
                    //this.start();
                    this.initListener();
                    if (this.screenType === 1) {
                        this.$refs.mainPage.style.maxWidth = "600px";
                    }
                })

                if (this.skipCheckTel) {
                    this.isRealName();
                }
                else {
                    this.isBindPhone();
                }

                this.iframeUrl = sdkUrl + "?gameId=" + this.gameId + "&token=" + localStorage.getItem("token") + "&from=" + this.from + "&noticeSwitch=" + this.noticeShowSwitch;
                //this.iframeUrl = "http://192.168.1.59:8081/f/#/sdk/main?gameId=" + this.gameId + "&token=" + localStorage.getItem("token") + "&from=h5";
            },
            heartBeat() {
                let options = {
                    url:"/h5/heartBeat",
                    data: {
                        shoutId: this.shoutId,
                        gameId: this.gameId
                    }
                };
                request(options).then(res => {
                    let c = false;
                    if (res.data.success) {
                        let msgList = res.data.data.shoutMsgList;
                        for (let i = 0; i < msgList.length; i++) {
                            let msg = msgList[i];
                            this.shoutId = msg.id;
                            if (this.noticeShowSwitch) {
                                this.shoutMsgList.push(msg);
                            }
                        }
                        c = true;
                    }
                    else {
                        console.log(res.data.error.message);
                        if (res.data.error.code !== '911') {
                            c = true;
                        }
                    }

                    if (c) {
                        setTimeout(() => {
                            this.heartBeat();
                        }, this.heartBeatTime);
                    }

                });
            },
            hideNotice() {
                setTimeout(() => {
                    this.showNotice = false;
                    this.showShoutMsg();
                }, 1000)
            },
            showShoutMsg() {
                if (this.shoutMsgList.length > 0) {
                    let msg = this.shoutMsgList[0];
                    if (this.shoutMsgList.length > 1) {
                        this.shoutMsgList = this.shoutMsgList.slice(1);
                    }
                    else {
                        this.shoutMsgList = [];
                    }

                    let msgResult = '';
                    if (msg.msgType === 1) {
                        this.noticeStyle = '';
                        msgResult = `[${msg.serverName}] ${msg.roleName} ：${msg.msg}`;
                    }
                    else if (msg.msgType === 2) {
                        this.noticeStyle = 'font-weight: bold; color: #E74C3C; ';
                        msgResult = `官方通知： ${msg.msg}`;
                    }
                    else {
                        msgResult = `${msg.msg}`;
                    }

                    this.noticeMessage = '                                                                                                    ' + msgResult;
                    this.noticeShowTime = new Date().getTime();
                    this.showNotice = true;
                    console.log('开始播放时间', this.noticeShowTime)
                }
                else {
                    setTimeout(() => {
                        this.showShoutMsg();
                    }, 3000);
                }
            },
            setSpeed(n) {
                console.log(n)
                this.speedRate = n;
                timerhook.setSpeed(n);
                //Toast('游戏当前加速倍率：' + n);
            },
            isBindPhone() {
                let user = JSON.parse(localStorage.getItem("user"));
                if (!user.phone) {
                    this.bingTelShow = true;
                    this.$nextTick(function () {
                        this.$refs.bindTelDialog.backShow = false;
                        this.$refs.bindTelDialog.missShow = true;
                    })
                } else {
                    this.isRealName();
                }
            },
            missBindTel() {
                this.bingTelShow = false;
                this.isRealName();
            },
            isRealName() {
                let user = JSON.parse(localStorage.getItem("user"));
                if (user.isUserCheck !== '1') {
                    this.realNameShow = true;
                    this.$nextTick(function () {
                        this.$refs.realNameDialog.inputEnable = true;
                        this.$refs.realNameDialog.missShow = user.forcePersonCheck !== '1';
                    })
                } else {
                    if (this.tempGameUrl) {
                        //console.log('h5游戏地址：', this.tempGameUrl)
                        this.startGame();
                    }
                    //this.gameUrl = 'http://192.168.68.106:8080/#/test';
                    //this.gameUrl = 'https://hlygames.com/#/test';
                }
            },
            missRealName() {
                this.realNameShow = false;
                this.startGame();
            },
            openFuliPage(url) {
                this.drawUrl = url;
                this.iframeDialogShow = true;
            },
            initListener() {
                window.addEventListener("message", this.listener);
            },
            listener(event) {
                console.dir(event);
                let me = this;
                if (event.data.operation === 'pay') {
                    console.log("触发支付");
                    let order = event.data.param;
                    me.openPayPage(order);
                } else if (event.data.operation === 'uploadGameRole') {
                    console.log("触发角色上报");
                    let param = event.data.param;
                    me.uploadRole(param);
                } else if (event.data.operation === 'repeatLogin') {
                    console.log("触发登陆被顶");
                    me.logout();
                } else if(event.data.operation === 'closeMenu') {
                    this.closeMainWindow();
                } else if(event.data.operation === 'logout'){
                    this.logout();
                } else if(event.data.operation === "startIntent") {
                    Toast(event.data.param.message);
                } else if (event.data.operation === 'showIOSPay') {
                    this.closeMainWindow();
                    this.payUrl = event.data.url;
                    this.diyDialogShow = true;
                } else if(event.data.operation === 'gameSpeed') {
                    this.setSpeed(event.data.param.speed);
                } else if(event.data.operation === 'openFullDialog') {
                    this.openFuliPage(event.data.url);
                } else if(event.data.operation === 'noticeSwitch') {
                    this.noticeShowSwitch = !this.noticeShowSwitch;
                } else if (event.data.operation === 'openAutoClick') {
                    this.autoClickListShow = true;
                } else if(event.data.operation === 'giveGift') {
                    this.closeMainWindow();
                    this.giveGiftPageShow = true;
                }
            },
            uploadRole(roleParam) {
                let params = {
                    channelId: this.channelId,
                    gameId: roleParam.gameId,
                    userId: roleParam.userId,
                    roleId: roleParam.roleId,
                    roleLevel: roleParam.roleLevel,
                    vipLevel: roleParam.vipLevel,
                    roleName: roleParam.roleName,
                    serverId: roleParam.serverId,
                    serverName: roleParam.serverName,
                    combatNum: roleParam.combatNum,
                    partyId: roleParam.partyId,
                    partyName: roleParam.partyName,
                    partyMasterId: roleParam.partyMasterId,
                    partyMasterName: roleParam.partyMasterName,
                    eventType: roleParam.eventType,
                    cpExt: roleParam.cpExt,
                    sign: roleParam.sign,
                }
                roleSync(params).then(res => {
                    if (res.data.success) {
                        this.$refs.gameIframe.contentWindow.postMessage({operation: "onRole", param: 'success'}, "*");
                    } else {
                        console.log(res.data.error.message);
                    }
                });
            },
            start() {
                this.$refs.countDown.reset();
                this.$refs.countDown.start();
            },
            reset() {
                this.$refs.countDown.reset();
            },
            finish() {
                this.unActiveButton();
            },
            //实现移动端拖拽
            down(event) {
                this.flags = true;
                let touch;
                if (event.touches) {
                    touch = event.touches[0];
                } else {
                    touch = event;
                }
                this.position.x = touch.clientX;
                this.position.y = touch.clientY;
                this.dx = floatIconView.offsetLeft;
                this.dy = floatIconView.offsetTop;
            },
            move(event) {
                if (this.flags) {
                    if (this.buttonHidden) {
                        this.activeButton();
                    }
                    let touch;
                    if (event.touches) {
                        touch = event.touches[0];
                    } else {
                        touch = event;
                    }
                    this.nx = touch.clientX - this.position.x;
                    this.ny = touch.clientY - this.position.y;
                    this.xPum = this.dx + this.nx;
                    this.yPum = this.dy + this.ny;
                    floatIconView.style.left = this.xPum + "px";
                    floatIconView.style.top = this.yPum + "px";
                    //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
                    document.addEventListener("touchmove", function () {
                        event.preventDefault();
                    }, false);
                }
            },
            end(event) {
                this.flags = false;
                if (!this.xPum) {
                    return;
                }

                let {
                    clientHeight: windowHeight,
                    clientWidth: windowWidth
                } = document.documentElement;
                // 计算后坐标  设置 按钮位置
                //this.halfOffset = -floatIconView.clientWidth / 2;
                if (this.yPum > 50 && this.yPum < (windowHeight - 150)) { //  不在顶部 且 不在底部
                    if (this.xPum <= (windowWidth / 2)) {  //  left 小于等于屏幕一半
                        floatIconView.style.left = 0;
                        floatIconView.style.right = 'auto';
                        //this.hiddenOnLeft();
                        this.start();
                    } else { //  left 大于屏幕一半
                        floatIconView.style.left = 'auto';
                        floatIconView.style.right = 0;
                        this.start();
                    }
                } else {
                    if (this.yPum <= 50) {  //  在顶部
                        floatIconView.style.top = 0;
                        floatIconView.style.bottom = 'auto';
                        this.start();
                    } else if (this.yPum >= (windowHeight - 150)) {
                        floatIconView.style.bottom = 0;
                        floatIconView.style.top = 'auto';
                        this.start();
                    }
                    if (this.xPum < 0) {
                        floatIconView.style.left = 0;
                        this.start();
                    } else if (this.xPum > (windowWidth - floatIconView.clientWidth)) {
                        floatIconView.style.right = 0;
                        floatIconView.style.left = 'auto';
                        this.start();
                    }
                }
            },
            activeButton() {
                //floatIconView.style.opacity = 1;
                this.buttonHidden = false;
                if (!floatIconView.style.left) {
                    floatIconView.style.left = "0px"
                }

                if (floatIconView.style.left === '-25px') {
                    floatIconView.style.left = "0px"
                } else if (floatIconView.style.right === '-25px') {
                    floatIconView.style.right = "0px"
                }
                /*floatIconView.style.transform = `translate3d(${this.halfOffset+'px'}, 0, 0)`;
                floatIconView.style.transition = 'transform 1s linear 0s';*/
            },
            unActiveButton() {
                //floatIconView.style.opacity = 0.2;
                this.buttonHidden = true;
                if (floatIconView.style.left === '0px') {
                    floatIconView.style.left = "-25px"
                } else if (floatIconView.style.right === '0px') {
                    floatIconView.style.right = "-25px"
                }

                /*floatIconView.style.transform = `translate3d(${this.halfOffset+'px'}, 0, 0)`;
                floatIconView.style.transition = 'transform 1s linear 0s';*/
            },
            showMainWindow() {
                if (this.buttonHidden) {
                    this.activeButton();
                    this.start();
                    return;
                }
                /*if (this.firstClick) {
                  this.firstClick = false;
                  return;
                }*/
                this.closeAll();
                this.jsPageShow = false;
                this.mainDialogShow = true;
            },
            closeMainWindow() {
                this.mainDialogShow = false;
                this.activeButton();
                this.start();
            },
            openOutsidePage(title, src, type) {
                /*this.videoPageDialogShow = true;
                this.videoPageShow = true;
                this.$nextTick(function () {
                  this.$refs.videoPage.show(title, src, type);
                })*/
                //this.$refs.webview_iframe.document.location.reload();
                //window.parent.document.getElementById('iframe');
                this.$refs.webview_iframe.contentWindow.location.reload(true);
                console.log(this.$refs.webview_iframe.contentWindow);
                this.closeMainWindow();
                let user = JSON.parse(localStorage.getItem('user'));
                this.openPageUrl = window.location.origin + user.webviewPageUrl;
                this.openPageShow = true;
            },
            closeOutsidePage() {
                this.openPageShow = false;
            },
            closeLuckyPage() {
                this.videoPageShow = false;
                this.videoPageDialogShow = false;
            },
            closeAll() {
                this.changePasswordShow = false;
                this.bingTelShow = false;
                this.unBingTelShow = false;
                this.realNameShow = false;
                this.kfShow = false;
            },
            testPay() {
                let order = {
                    goodsName: '测试商品',
                    money: '200',
                    gameId: '101',
                };
                this.openPayPage(order);
            },
            openPayPage(order) {
                this.payShow = true;
                this.$nextTick(function () {
                    this.$refs.pay.initOrder(order);
                    this.$refs.pay.getBalance();
                })
            },
            openPayUrl(url, payType, price, oPrice, orderId, payCodeType) {
                this.payShow = false;
                if (this.isMobile()) {
                    this.payUrl = url;
                    let ua = navigator.userAgent.toLowerCase();
                    if (/iphone|ipad|ipod/.test(ua)) {//判断是否ios
                        this.diyDialogShow = true;
                    } else {
                        window.open(this.payUrl, '');
                    }
                } else {
                    this.payCodeShow = true;
                    this.$nextTick(function () {
                        let data = {
                            payString: url,
                            payType: payType,
                            payPrice: price,
                            payOriginalPrice: oPrice,
                            orderId: orderId,
                            payCodeType: payCodeType,
                        }
                        this.$refs.payCode.init(data);
                    });

                }

            },
            refreshPage() {
                this.gameUrl = '';
                setTimeout(() => {
                    this.gameUrl = this.tempGameUrl;
                }, 1000)

            },
            closeDiyDialog() {
                this.diyDialogShow = false;
            },
            isMobile() {
                return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            },
            closePayPage() {
                this.payShow = false;
            },
            confirmLogout() {
                Dialog.confirm({
                    message: '确认要退出登录吗?',
                }).then(() => {
                    this.logout();
                })
            },
            logout() {
                logout().then(res => {
                    this.logoutCallback();
                })
            },
            logoutCallback() {
                window.removeEventListener("message", this.listener);
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('loginUrl');
                Toast('已退出登录');
                this.mainDialogShow = false;
                this.changePasswordShow = false;
                this.bingTelShow = false;
                this.unBingTelShow = false;
                this.realNameShow = false;
                this.kfShow = false;
                this.openPageShow = false;
                this.videoPageShow = false;
                this.videoPageDialogShow = false;
                this.payDialogShow = false;
                this.payCodeShow = false;
                this.diyDialogShow = false;
                this.step = 1;
                this.gameUrl = null;
                if (this.isAutoLogin) {
                    notice.exitGame();
                }
                else {
                    window.location.reload();
                }
            },
        }
    }
</script>

<style scoped>
    .main-dialog {
        width: 88%;
        max-width: 300px;
        max-height: 320px;
        /*box-shadow: 2px 2px 10px 3px rgba(255,255,255,.2);*/
    }

    .pay-code-dialog {
        width: 88%;
        padding-bottom: 5px;
        max-width: 300px;
    }

    .pay-dialog {
        width: 88%;
        max-width: 300px;
    }

    .main-page {
        position: relative;
        background-color: #ffffff;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        touch-action: none;
        margin: 0 auto;
    }

    .iframe-dialog {
        background-color: #ffffff;
        width: 100vw;
        height: 100vh;
        padding: 0;
        overflow: hidden;
    }

    .back-div {
        background-color: #eceaea;
    }

    .right-panel {
        position: absolute;
        background-color: white;
        width: 100%;
        height: 95%;
        top: 5%;
        right: 0;
    }

    .dialog-mask {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        background-color: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: 0;
    }

    .diy-dialog {
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 8px 1px 8px;
        box-sizing: border-box;
        text-align: left;
        font-size: 14px;
        width: 80%;
        max-width: 300px;
        border-radius: 10px;
        margin: 200px auto 0;

    }

    .diy-dialog-buttons {
        padding: 0 15px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 0;
        margin-top: 30px;
        border-top: 1px solid #f0f0f0;
    }

    .float-icon {
        position: fixed;
        touch-action: none;
        height: 50px;
        width: 50px;
        /* 如果碰到滑动问题，1.3 请检查 z-index。z-index需比web大一级*/
        z-index: 999;
        top: 70%;
        left: -25px;
    }
    /deep/.van-notice-bar__content{
        white-space:pre;
    }

    @keyframes changeIconSize {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
        }
    }

    .has-red-icon {
        animation: changeIconSize 1s infinite alternate;
    }

    .auto-click-view {
        font-size: 10px;
        position: absolute;
        right: 10px;
        top: 70%;
        user-select: none;
        cursor: pointer;
        background-color: #ffffff;
        border: 1px solid #eceaea;
        box-shadow: 2px 2px 10px 3px rgba(0,0,0,.1);
        padding: 8px 0;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #e73d50;
    }
    .rp-view {
        background-color: rgba(0, 0, 0, 0.7);
        box-sizing: border-box;
        width: 30px;
        height: 30px;
        border-radius: 30px;
        position: absolute;
        color: #cccccc;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        cursor: pointer;
    }
</style>
